import * as React from 'react';
import * as classNames from 'classnames';
import * as CreDtos from "../../../CRE.dtos";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Spinner } from '../../Controls/Spinner';
import * as PeopleActionCreators from "../../../actions/people.actions";
import UploadTemporaryFile from '../../controls/UploadTemporaryFile';

export interface IPersonProps {
    person: CreDtos.People;
    cancel: Function;
    upsert: Function;
    isSaving: boolean;
}

interface IPersonState {
    person: CreDtos.People;
}

class Person extends React.Component<IPersonProps, IPersonState> {
    constructor(props: IPersonProps) {
        super(props);
        this.state = {
            person: new CreDtos.People()
        }
        this.onValueChanged = this.onValueChanged.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onCategoryValueChanged = this.onCategoryValueChanged.bind(this);
    }

    componentDidMount() {
        this.setState({ person: { ...this.props.person } });
    }

    componentDidUpdate(prevProps) {
        if (this.state.person.id != this.props.person.id) {
            this.setState({ person: { ...this.props.person } });
        }
    }

    onValueChanged(fieldName: string, value: any) {
        var person = { ...this.state.person };
        person[fieldName] = value;
        this.setState({ person })
    }

    onCategoryValueChanged(index: number, fieldName: string, value: any) {
        var person = { ...this.state.person };
        if (fieldName == "sortOrder") {
            try {
                let intValue = parseInt(value);
                person.peopleCategories[index][fieldName] = intValue;
            } catch { }
        }
        else {
            person.peopleCategories[index][fieldName] = value;
        }
        this.setState({ person })
    }

    onSave() {
        this.props.upsert(this.state.person);
    }

    render() {
        let content;

        if (this.state.person) {

            let categories;
            if (this.state.person.peopleType == 2 && this.state.person.peopleCategories) {
                let categoryItems = this.state.person.peopleCategories.map((item, index) => {
                    return (
                        <div className="row" key={"peopleCategories_" + item.categoryId}>
                            <div className="col-12 mb-1 ">
                                <label>
                                    <input type="checkbox" value="" disabled={this.props.isSaving} checked={item.enabled} onClick={() => this.onCategoryValueChanged(index, "enabled", !item.enabled)} />
                                    {item.categoryName}
                                </label>
                            </div>
                            {item.enabled && (
                                <div className="col-12">
                                    <div className="card grey-bg">
                                        <div className="card-block">
                                            <div className="row">
                                                <div className="col-12 mb-1 ">
                                                    <div className="mb-0 form-group">
                                                        <label >Sub title (optional)</label>
                                                        <input type="text"
                                                            className="form-control"
                                                            placeholder="e.g. NSW representative..."
                                                            disabled={this.props.isSaving}
                                                            value={item.subtitle}
                                                            onChange={e => this.onCategoryValueChanged(index, "subtitle", e.target.value)}
                                                            maxLength={255} />
                                                    </div>
                                                </div>
                                                <div className="col-12 mb-1 ">
                                                    <div className="mb-0 form-group">
                                                        <textarea id="textarea"
                                                            className="form-control"
                                                            placeholder="Summary..."
                                                            disabled={this.props.isSaving}
                                                            value={item.text}
                                                            onChange={e => this.onCategoryValueChanged(index, "text", e.target.value)}
                                                            rows={5}></textarea>
                                                    </div>
                                                </div>
                                                <div className="col-12 mb-1 ">
                                                    <div className="mb-0 form-group">
                                                        <label >Link (optional)</label>
                                                        <input type="text"
                                                            className="form-control"
                                                            disabled={this.props.isSaving}
                                                            placeholder="https://www..."
                                                            value={item.link}
                                                            onChange={e => this.onCategoryValueChanged(index, "link", e.target.value)}
                                                            maxLength={255} />
                                                    </div>
                                                </div>
                                                <div className="col-12 mb-1 ">
                                                    <div className="mb-0 form-group">
                                                        <label >Sort Order</label>
                                                        <input type="number"
                                                            className="form-control"
                                                            disabled={this.props.isSaving}
                                                            placeholder="0"
                                                            value={item.sortOrder}
                                                            onChange={e => this.onCategoryValueChanged(index, "sortOrder", e.target.value)}
                                                            maxLength={255} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )
                });
                categories = (
                    <div className="col-12">
                        <strong>Categories</strong>
                        {categoryItems}
                    </div>
                );
            }

            let img = this.state.person.img;
            if (!img || img.length == 0) {
                img = "./images/Unconfirmed.png";
            }

            content = (
                <div className="card lightgrey-bg">
                    <div className="card-block">
                        <div className="row">
                            <div className="col-12 col-md-9 push-md-3">
                                <div className="row">
                                    <div className="col-12 mb-1 ">
                                        <strong>Person</strong>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <input type="text" className="form-control"
                                                placeholder="First name..."
                                                disabled={this.props.isSaving}
                                                value={this.state.person.firstName}
                                                onChange={(e) => this.onValueChanged("firstName", e.target.value)}
                                                maxLength={255} />
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <input type="text"
                                                className="form-control"
                                                placeholder="Last name..."
                                                disabled={this.props.isSaving}
                                                value={this.state.person.lastName}
                                                onChange={(e) => this.onValueChanged("lastName", e.target.value)}
                                                maxLength={255} />
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <input type="text"
                                                className="form-control"
                                                placeholder="Defaults to first and last name if empty..."
                                                disabled={this.props.isSaving}
                                                value={this.state.person.title}
                                                onChange={(e) => this.onValueChanged("title", e.target.value)}
                                                maxLength={255} />
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <label >Link (optional)</label>
                                            <input type="text"
                                                className="form-control"
                                                disabled={this.props.isSaving}
                                                placeholder="https://www..."
                                                value={this.state.person.link}
                                                onChange={e => this.onValueChanged("link", e.target.value)}
                                                maxLength={255} />
                                        </div>
                                    </div>
                                    <div className="d-none col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <select className="form-control" disabled={this.props.isSaving} onChange={e => this.onValueChanged("peopleType", e.target.value)}>
                                                <option value="1" selected={this.state.person.peopleType == 1}>External</option>
                                                <option value="2" selected={this.state.person.peopleType == 2}>Internal</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <UploadTemporaryFile onUpdated={(path) => this.onValueChanged("img", path)} />
                                        <p>The preferred aspect ratio 5:4</p>
                                    </div>
                                    <div className="col-12 mb-1 show-sm">
                                        <div>
                                            <img src={img} style={{width: "100%"}} />
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <label>
                                            <input type="checkbox"
                                                checked={this.state.person.enabled}
                                                disabled={this.props.isSaving}
                                                onClick={() => this.onValueChanged("enabled", !this.state.person.enabled)}
                                            />
                                            Enabled
                                    </label>
                                    </div>
                                    {categories}
                                    <div className="col-12">
                                        <p></p>
                                    </div>
                                    <div className="col-12">
                                        <div className="pull-right">
                                            <button type="reset" className="btn btn-primary mr-2" disabled={this.props.isSaving} onClick={() => this.props.cancel()}>CANCEL</button>
                                            <button type="button" className="btn btn-primary" disabled={this.props.isSaving} onClick={() => this.onSave()}>SAVE</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-12 col-md-3 pull-md-9 hide-sm">
                                <div>
                                    <img src={img} style={{width: "100%"}} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div>
                {content}
            </div>
        );

    }
}


const mapStateToProps = (state, ownProps) => {
    return {
        person: state.people.person,
        isSaving: state.people.isSaving
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            cancel: PeopleActionCreators.peopleCancel,
            upsert: PeopleActionCreators.peopleUpsertRequest
        },
        dispatch
    );
};


const PersonContainer = connect(mapStateToProps, mapDispatchToProps)(
    Person
);

export default PersonContainer;


// WEBPACK FOOTER //
// ./src/components/Administration/People/Person.tsx